"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const phone = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-phone` : '') + (description ? ` desc-phone` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-phone"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-phone"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_1956)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.82756 1.14691L1.48166 2.49408C0.0672538 3.91268 -0.154898 6.13027 0.949992 7.80128C4.96746 13.8484 10.1503 19.0317 16.1955 23.0486C17.8686 24.1556 20.0879 23.9328 21.5065 22.5163L22.8529 21.1709C24.0489 19.9744 24.0489 18.0354 22.8532 16.8392L20.3987 14.3868C19.8246 13.8124 19.0453 13.4895 18.2327 13.4895L18.0303 13.4961C17.2916 13.545 16.5929 13.8603 16.0663 14.3871L15.733 14.719L15.5838 14.5941C13.3601 12.7036 11.2929 10.6362 9.40257 8.41234L9.27801 8.26401L9.61158 7.93558C10.1888 7.35856 10.5117 6.57923 10.5117 5.76659C10.5117 4.95396 10.1888 4.17463 9.6141 3.60011L7.15863 1.14674C5.96266 -0.0489633 4.02369 -0.0489633 2.82756 1.14691ZM6.09825 2.20769L8.55376 4.66109C8.8469 4.95413 9.01168 5.35186 9.01168 5.76659C9.01168 6.18132 8.8469 6.57905 8.55361 6.87224L7.73384 7.68401C7.45852 7.95664 7.43619 8.39411 7.68232 8.69336C9.96975 11.4744 12.5218 14.0267 15.3026 16.3143C15.6008 16.5596 16.0364 16.5384 16.3094 16.2654L17.1271 15.4476C17.4204 15.1542 17.818 14.9895 18.2327 14.9895C18.6473 14.9895 19.045 15.1542 19.3381 15.4475L21.7927 17.9C22.4026 18.5101 22.4026 19.4997 21.7923 20.1101L20.4464 21.455C19.5323 22.3678 18.102 22.5114 17.0245 21.7984C11.1467 17.8928 6.10641 12.8521 2.2003 6.9726C1.48905 5.8969 1.63224 4.46753 2.54389 3.55317L3.88841 2.20738C4.49848 1.59744 5.48787 1.59744 6.09825 2.20769Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_1956"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = phone;